import { StyleSheet, Text, View, Image, TouchableOpacity, Dimensions, StatusBar, ScrollView, ImageBackground, TextInput, TouchableWithoutFeedback, FlatList, Alert} from 'react-native';
import React, {useRef, useState, useEffect, Component} from 'react';
import { FontAwesome5, Feather, MaterialIcons } from '@expo/vector-icons'
import AppLoader, { showLoader, loaderRef, hideLoader } from './AppLoader';
import { SafeAreaView } from 'react-native-safe-area-context';
import { ActivityIndicator } from 'react-native';
import * as RootNavigation from '../RootNavigation';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { PricingCard } from "@rneui/themed";
import * as WebBrowser from 'expo-web-browser';

const {width, height} = Dimensions.get('window')



  
export default class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
            
            email: this.props.route.params.email,
            plan: this.props.route.params.plan,
            amount: this.props.route.params.amount,
            days: this.props.route.params.days,
            result: null,

            
            
        }

        
  
      }

      componentDidMount() {
        this.openPaymentPage();
        

      } 
      
      openPaymentPage = async () => {
        let data = 'email=' + this.state.email + '&plan=' + this.state.plan + '&amount=' + this.state.amount + '&days=' + this.state.days;
        let result = await WebBrowser.openBrowserAsync('https://ios.breketefamily.com/renew-subscription.php?'+data);
       this.setState({ result });
      };

      verifyPayment = async () => {
          showLoader();
          let data = 'email=' + this.state.email + '&plan=' + this.state.plan + '&amount=' + this.state.amount + '&days=' + this.state.days;
          fetch('https://ios.breketefamily.com/verify.php?'+data,
          { method: 'GET' })
          .then((response) => response.json())
          .then((responseJson) => {
            // console.log(responseJson)
            if (responseJson.status == 0 && responseJson.data) {
              alert(responseJson.message);
              //update item user in asyncstorage
              try{
                AsyncStorage.setItem('user', JSON.stringify(responseJson.data));
                //RootNavigation.navigate('Home');
              }catch(e){
                console.log(e);
               // RootNavigation.navigate('Home');
              }

              
              //update item user in sqlite
            }else{
              hideLoader();
             // alert(responseJson.response);
            }
          
              
             
 
             
          }).then(() => {
            hideLoader();
            RootNavigation.navigate('Home');
          }
          )


      }

render(){

  return (
    <SafeAreaView>
    <View style={{flex:1}}>
      <AppLoader ref = { loaderRef } />
     
      </View>
    <TouchableOpacity style={{flex:1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#90ee90'}} onPress={() => this.verifyPayment()}>
      <Text>Verify Payment</Text>
    </TouchableOpacity>
    </SafeAreaView>

  );
}
 

}

const styles = StyleSheet.create({


// CAROUSEL STYLES

carouselImage: {
    width: 200, 
    height: 320, 
    borderRadius: 10, 
    alignSelf: 'center',
    backgroundColor: 'rgba(0,0,0,0.9)'
},
carouselText: {
    paddingLeft: 14,
    color: 'white', 
    position: 'absolute', 
    bottom: 10, 
    left: 2, 
    fontWeight: 'bold'
},
carouselIcon: {
    position: 'absolute', 
    top: 15, 
    right: 15
},
carouselContentContainer: {
    flex: 1,
    backgroundColor: '#000',
    height: 720,
    paddingHorizontal: 14
  },
SearchboxContainer: {
    flexDirection: 'row',
    marginVertical: 20, 
    width: '95%',
    alignSelf: 'center', 
    backgroundColor: '#fff', 
    elevation: 10,
    borderRadius: 4,
  },
  Searchbox: {
    padding: 12,
    paddingLeft: 20,
    fontSize: 16,
  },
  SearchboxIcon: {
    position: 'absolute', 
    right: 20, 
    top: 14
  },
  ImageBg: {
    flex: 1,
    height: null,
    width: null,
    opacity: 1,
    justifyContent: 'flex-start',  
  },
  carouselContainerView: {
    width: '100%',
    height:350 ,
    justifyContent: 'center',
    alignItems: 'center',
},
  carousel: {
    flex:1,
    overflow: 'visible',
} ,
movieInfoContainer: {
  flexDirection: 'row', 
  marginTop: 16, 
  justifyContent: 'space-between', 
  width: Dimensions.get('window').width - 14
},
movieName: {
  paddingLeft: 14,
  color: 'white', 
  fontWeight: 'bold', 
  fontSize: 20,
  marginBottom: 6
},
movieStat: {
  paddingLeft: 14,
  color: 'white', 
  fontWeight: 'bold', 
  fontSize: 14, 
  opacity: 0.8
},
playIconContainer: {
  backgroundColor: '#212121',
  padding: 18,
  borderRadius: 40,
  justifyContent: 'center',
  alignItems: 'center',
  elevation: 25,
  borderWidth: 4,
  borderColor: 'rgba(2, 173, 148, 0.2)',
  marginBottom: 14
}
});
